/* @flow */
import Flux from 'flux';
import { getActions } from 'pusher/PusherEventParser';

class Dispatcher extends Flux.Dispatcher {
  handlePusherEvent(pusherEvent: Object) {
    if (__DEV__) {
      console.log('Pusher Event', pusherEvent);
    }

    const actions = getActions(pusherEvent);
    actions.forEach(action => this.dispatch(action));
  }
}

/* This is a class helping use transition
 * from Flux to Redux, you should never use this class
 * from within a React Component (use react-redux connect HOC)
 * This class is only usefull if you want to dispatch redux action
 * from flux actions.
 *
 * For example if you have a redux store that need to listen to CurrentUser
 * store. Because CurrentUser is a Flux store it doesn't emit redux action.
 * You could use this class to dispatch redux actions from withing the flux action.
 */
class ReduxDispatcher {
  dispatch: *;

  constructor() {
    this.dispatch = () => {
      if (!__TEST__) {
        console.error('Redux dispatcher called before being set');
      }
    };
  }

  setDispatch(dispatch: *) {
    this.dispatch = dispatch;
  }
}

// We have a single dispatcher because our app is pretty small. This is in the
// Dispatcher module as a convenient refactoring from a module export.
export const dispatcher = new Dispatcher();
export const reduxDispatcher = new ReduxDispatcher();
export default Dispatcher;



// WEBPACK FOOTER //
// ./src/lib/Dispatcher.js